//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectMarshallTask, setMarshallTask } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const MarshallTaskSwitch = () => {

    //redux
    const dispatch = useDispatch();
    const marshallTask = useSelector(selectMarshallTask);
    const usedTheme = useSelector(selectUsedTheme);

    const handleSwitch = () => {
        dispatch(setMarshallTask(!marshallTask));
    }

    return (

        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Marshall Task
                </span>
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={marshallTask}
                    value={marshallTask}
                    style={{ marginLeft: "16px" }}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Enable Marshall Task functionality for timeline management
            </span>
        </div>


    )
}

export default MarshallTaskSwitch






